import { Component, OnInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";

import { MainConfig } from "@atenea-cms";
import { DownloadService } from "../shared";

@Component({
  selector: "download-list",
  templateUrl: "./download-list.component.html",
  styleUrls: ["./download-list.component.scss"],
  host: { class: "atn-list-crud" },
})
export class DownloadListComponent implements OnInit {
  constructor(
    private titleService: Title,
    private mainConfig: MainConfig,
    public dataService: DownloadService
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Descargas - " + this.mainConfig.cmsName);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/downloads/download-list/download-list.component.ts